import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ButtonComponent } from "@kinomap-dev/ng-ui-lib";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'app-delete-activity-modal',
    styleUrl: 'deleteActivityModal.component.scss',
    imports: [ButtonComponent, TranslateModule],
    standalone: true,
    template: `
    
    <p>{{ 'modal.activity-delete.content' | translate}}</p>
    
    <footer>
        <kin-btn (onClick)="cancel.emit()" >Annuler</kin-btn>
        <kin-btn (onClick)="confirm.emit()" color="danger">Supprimer</kin-btn>
    </footer>
    `,
})

export class DeleteActivityModalComponent {
    @Output() cancel: EventEmitter<void> = new EventEmitter<void>();
    @Output() confirm: EventEmitter<void> = new EventEmitter<void>();
}